import {DataLayerModel} from "@merchant-webapp/components";
import {DashboardTypeEnum} from "../../../app/components/dashboard/enums/dashboard-type.enum";

export class DashboardTimeSpentDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "DASHBOARD_TIME_SPENT";
	public dashboardType: DashboardTypeEnum;
	public dashboardTimeSpentInSeconds: number;

	public constructor(dashboardType: DashboardTypeEnum, timeSpentInSeconds: number) {
		super(DashboardTimeSpentDataLayerModel.EVENT_NAME);
		this.dashboardType = dashboardType;
		this.dashboardTimeSpentInSeconds = timeSpentInSeconds;
	}
}